import React from 'react';
import { Search } from './components/Search';
import { CreateBtn } from './components/CreateBtn';
import { ClientTypeSelect } from './components/ClientTypeSelect';
import { StatusSelect } from './components/StatusSelect';
import { ResetBtn } from './components/ResetBtn';
import { SortAndCount } from './components/SortAndCount';
import { WithURLFilters } from './components/WithURLFilters';

export const CustomersControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className="flex flex-col gap-4">
				<div className="flex items-center gap-4">
					<Search />
					<CreateBtn />
				</div>
				<div className="flex items-end gap-4">
					<ClientTypeSelect />
					<StatusSelect />
					<ResetBtn />
					<SortAndCount />
				</div>
			</div>
		</WithURLFilters>
	);
};
